import {XHRApi} from './xhr-api'

export class Helper {

    /**
     * @param headers
     * @returns {XHRApi}
     * @constructor
     */
    XHRAPI(headers = {}) {
        return new XHRApi(headers);
    }

    /**
     * ```
     * Example One:
     *
     * const originalUrl = "http://example.com/page?existingParam=oldValue";
     * const updatedUrl = URLParameters(originalUrl, {one: "1", existingParam: "updatedValue"});
     * console.log(updatedUrl); // http://example.com/page?existingParam=updatedValue&one=1
     *
     * Example Two:
     * const originalUrl = "http://example.com/page";
     * const updatedUrl = URLParameters(originalUrl, {one: "1", arrayParam: ["value1", "value2"]});
     * console.log(updatedUrl); // http://example.com/page?one=1&arrayParam%5B%5D=value1&arrayParam%5B%5D=value2
     *
     * You'll be able to collect arrayParam value in PHP using: $_GET['arrayParam'], would return ["value1", "value2"] in PHP
     * ```
     * @param url
     * @param paramsObj
     * @returns {string}
     * @constructor
     */
    URLParameters(url, paramsObj) {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);

        for (const param in paramsObj) {

            if (paramsObj.hasOwnProperty(param)) {
                const value = paramsObj[param];

                if (Array.isArray(value)) {
                    // Remove all occurrences of the parameter before adding new values
                    const encodedParam = encodeURIComponent(`${param}[]`);
                    params.forEach((paramValue, paramName) => {
                        if (encodeURIComponent(paramName) === encodedParam) {
                            params.delete(paramName);
                        }
                    });
                    // Append the new values for the array parameter
                    value.forEach(item => params.append(`${param}[]`, item));
                } else {
                    // Otherwise, set the single value for the parameter
                    params.set(param, value);
                }
            }

        }

        urlObj.search = params.toString();

        return urlObj.toString();
    }

}

